import React from "react";
import ObsIframe from "../../iframe-component/onboarding/ObsIframe";

const InstallationConfirmationLetter = () => {
  return <ObsIframe path="/ackletter" />;
};

export default React.memo(InstallationConfirmationLetter);
